// Offline read-keş — YALNIZ "Offline rejim" tikli tenantda (flag license-grace cavabından gəlir).
// Online olanda whitelist GET cavablarını localStorage-a yazır; internet gedəndə həmin cavabı qaytarır.
// Flag SÖNÜLÜ olanda heç nə edilmir (additive — online davranış dəyişmir).
// Lisenziya güzəşti: yalnız BU GÜN onlayn keçibsə offline keş verilir; tarix dəyişəndə (sabah) online tələb.

const GRACE_KEY = 'pos_license_grace';
const CACHE_PREFIX = 'offcache:';

const bakuToday = () => new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Baku', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(new Date());

export const getGrace = () => {
    try { return JSON.parse(localStorage.getItem(GRACE_KEY) || 'null'); } catch { return null; }
};

// Offline rejim bu tenantda açıqdır? (son online /auth/license-grace cavabından saxlanıb)
export const offlineEnabled = () => { const g = getGrace(); return !!(g && g.offline); };

// Lisenziya güzəşti bu gün üçün etibarlıdır? (offline icazə yalnız 1 günlük)
const GRACE_NIGHT_HOURS = 6; // dünənki güzəşt bu saata (Bakı) qədər qüvvədədir
const bakuYesterday = () => new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Baku', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(new Date(Date.now() - 24 * 3600 * 1000));
const bakuHour = () => Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Baku', hour: '2-digit', hour12: false }).format(new Date())) % 24;
export const graceValidToday = () => {
    const g = getGrace();
    if (!(g && g.token)) return false;
    if (g.date === bakuToday()) return true;
    return g.date === bakuYesterday() && bakuHour() < GRACE_NIGHT_HOURS; // gecə növbəsi kəsilməsin
};

// Offline hesab cəmi üçün servis ayarları (son online güzəşt cavabından). Kassa serverdə autoritar.
export const getOfflineSettings = () => { const g = getGrace(); return (g && g.settings) || { service_percent: 0, service_min_amount: 0 }; };

// Keşlənə bilən GET yolları (ofisiant/kassa üçün oxu məlumatı)
// '/printers' prefiksi '/printers/pc-ip' (çap ayarları: iri font, miqdar formatı) da daxildir → offline çapda qalır
// '/auth/tenant-logins' = giriş ekranındakı istifadəçi siyahısı (admin / kassir_ / anbar_), offline da görünsün
const CACHEABLE = ['/menu/full', '/tables', '/rooms', '/printers', '/auth/waiters', '/auth/offline-waiters', '/auth/tenant-logins', '/auth/login-screen-config', '/orders/'];
export const isCacheableGet = (method, url) => {
    if (String(method || 'get').toLowerCase() !== 'get') return false;
    const u = String(url || '');
    return CACHEABLE.some((p) => u.startsWith(p) || u.includes(p));
};

export const writeCache = (url, data) => {
    try { localStorage.setItem(CACHE_PREFIX + url, JSON.stringify({ t: Date.now(), data })); }
    catch { /* localStorage dolubsa səssiz keç */ }
};

// Offline ofisiant siyahısı (masa açanda picker üçün) — keşlənmiş /auth/offline-waiters-dən.
// /auth/waiters offline alınmayanda fallback kimi istifadə olunur.
export const getOfflineWaiterList = () => {
    try {
        const token = localStorage.getItem('pos_waiter_token') || '';
        const cached = JSON.parse(localStorage.getItem(CACHE_PREFIX + `/auth/offline-waiters?token=${encodeURIComponent(token)}`) || 'null');
        const data = cached ? cached.data : null;
        let ws = (data && data.waiters) || [];
        // Keş yoxdursa → offline giriş paketindəki siyahı (utils/offlineAuth.js yazır)
        if (!ws.length) {
            try { ws = (JSON.parse(localStorage.getItem('pos_offline_auth') || 'null') || {}).waiters || []; } catch { ws = []; }
        }
        return ws
            .filter((w) => ['waiter', 'administrator'].includes(String(w.role || '').toLowerCase()) && Number(w.id) > 0)
            .map((w) => ({ id: w.id, name: w.name, active: 1 }));
    } catch { return []; }
};

export const readCache = (url) => {
    try {
        const r = JSON.parse(localStorage.getItem(CACHE_PREFIX + url) || 'null');
        return r ? r.data : null;
    } catch { return null; }
};
